import { render, staticRenderFns } from "./6-common-year.vue?vue&type=template&id=7892ccfc&scoped=true&"
import script from "./6-common-year.vue?vue&type=script&lang=js&"
export * from "./6-common-year.vue?vue&type=script&lang=js&"
import style0 from "./6-common-year.vue?vue&type=style&index=0&id=7892ccfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892ccfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7892ccfc')) {
      api.createRecord('7892ccfc', component.options)
    } else {
      api.reload('7892ccfc', component.options)
    }
    module.hot.accept("./6-common-year.vue?vue&type=template&id=7892ccfc&scoped=true&", function () {
      api.rerender('7892ccfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/6-common-year.vue"
export default component.exports